var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top_native"},[_c('div',{staticClass:"contentText"},[_c('img',{attrs:{"src":_vm.list.length>0?_vm.list[0].imgUrl:'',"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }